export const FENCE_TYPE_ENTRY = 1;
export const FENCE_TYPE_OUT = 2;
export const FENCE_TYPE_ENTRY_OUT = 3;
export const FENCE_TYPES = [
  {
    type: FENCE_TYPE_ENTRY,
    name: 'Entrada',
  },
  {
    type: FENCE_TYPE_OUT,
    name: 'Salida',
  },
  {
    type: FENCE_TYPE_ENTRY_OUT,
    name: 'Entrada / Salida',
  },
];
